export default "__VITE_ASSET__DSYlNTPi__"